<script lang="ts">
  import SharedWorkOrderAsyncSelect from "../../../../../../../../../../../../../../../../_shared/_modules/work-order-async-select"
  import type { WorkOrderAssignmentSelection } from "../../../../../../contract"

  type Props = {
    organizationId: string
    disabled?: boolean
    brightBackground?: boolean
    id?: string
    placeholder?: string
    defaultPropertyId?: string | null
    preferredSelections?: WorkOrderAssignmentSelection[]
    onChange?: (selection: WorkOrderAssignmentSelection | null) => void
  }

  type PublicProps = Props & {
    value?: string
    selectedWorkOrder?: WorkOrderAssignmentSelection | null
  }

  let {
    organizationId,
    disabled = false,
    brightBackground = true,
    id = "work-order-assignment-select",
    placeholder = "Auftrag auswählen",
    defaultPropertyId = null,
    preferredSelections = [],
    onChange = undefined,
    value = $bindable(""),
    selectedWorkOrder = $bindable<WorkOrderAssignmentSelection | null>(null),
  }: PublicProps = $props()
</script>

<SharedWorkOrderAsyncSelect
  bind:value
  bind:selectedWorkOrder
  {organizationId}
  {disabled}
  {brightBackground}
  surfaceTone="light"
  {id}
  {placeholder}
  {defaultPropertyId}
  {preferredSelections}
  {onChange}
/>
